import { useStore } from '..'
import { OpenDialogFunction } from './slice'

export function useOpenDialog(): OpenDialogFunction {
  const openDialog = useStore((state) => state.dialogs.openDialog)
  return openDialog as OpenDialogFunction
}

export function useCloseDialog(): () => void {
  const closeDialog = useStore((state) => state.dialogs.closeDialog)
  return closeDialog
}

export function useOpenedDialog(): string | undefined {
  const openedDialog = useStore((state) => state.dialogs.openedDialog)
  return openedDialog?.config.name
}
